import { FLIPT_FLAGS } from "@/constants/constants";
import { getFliptFlag } from "@/helpers/get-flipt-flag";

/**
 * Evaluated after auth: the flag context needs the tenant from the token.
 * An unreachable Flipt reports the flag off, which keeps the trackers loading
 * without a banner as they did before consent existed.
 */
const fetchIsCookieConsentEnabled = async (): Promise<boolean> => {
	try {
		const result = await getFliptFlag({
			flagKey: FLIPT_FLAGS["enable-cookie-consent"],
		});
		return result.enabled;
	} catch {
		return false;
	}
};

export { fetchIsCookieConsentEnabled };
